/**
 * 视频播放浮层（任务 14.3）：原生 <video controls> 黑底全屏，不自研播放器——
 * 旧版无内嵌播放器（点击即播），新版同级（任务清单口径）。playsInline 防
 * iOS 跳系统全屏播放器（standalone 下跳出回不来）；Esc / 点黑底 / 关闭钮退出。
 * 体量极小（无依赖），静态 import 不做懒加载壳。
 */
import { useLayoutEffect } from 'preact/hooks';
import styles from './videoOverlay.module.scss';

export function VideoOverlay({ url, onClose }: { url: string; onClose: () => void }) {
  useLayoutEffect(() => {
    const onKey = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
  return (
    <div
      className={styles.overlay}
      data-testid="video-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <video
        className={styles.video}
        src={url}
        controls
        autoPlay
        playsInline
        data-testid="video-player"
      />
      <button
        type="button"
        className={styles.close}
        data-testid="video-close"
        aria-label="关闭"
        onClick={onClose}
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6.4 5 5 6.4 10.6 12 5 17.6 6.4 19 12 13.4 17.6 19l1.4-1.4L13.4 12 19 6.4 17.6 5 12 10.6z" />
        </svg>
      </button>
    </div>
  );
}
